<template>
  <span class="icon |" :class="classes">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        class="s"
        stroke="currentColor"
        d="M15,4.658a1.5,1.5,0,0,0-1.571.142L6.828,9h-3a1.5,1.5,0,0,0-1.5,1.5v3a1.5,1.5,0,0,0,1.5,1.5h3l6.6,4.2a1.5,1.5,0,0,0,2.4-1.2V6A1.5,1.5,0,0,0,15,4.658Z"
      ></path>
      <path class="s" stroke="currentColor" d="M20.328,15a3.509,3.509,0,0,0,0-5.523"></path>
      <line class="s" stroke="currentColor" x1="6.828" y1="9" x2="6.828" y2="15"></line>
    </svg>
  </span>
</template>
<script>
export default {
  props: ["classes"]
};
</script>
